import { apiClient } from "@/lib/api/client";

export type DeviceCategoryDto = {
  id: string;
  name: string;
  description: string | null;
  is_active: boolean;
};

export type DeviceCategoryInput = Pick<DeviceCategoryDto, "name" | "description" | "is_active">;

export type DeviceCategoryPageDto = {
  items: DeviceCategoryDto[];
  total: number;
  next_offset: number | null;
};

export async function listDeviceCategories(params: { search?: string; limit?: number; offset?: number; includeInactive?: boolean } = {}): Promise<DeviceCategoryPageDto> {
  const { data } = await apiClient.get<DeviceCategoryPageDto>("/device-categories", {
    params: {
      include_inactive: params.includeInactive ?? true,
      search: params.search || undefined,
      limit: params.limit ?? 25,
      offset: params.offset ?? 0,
    },
  });
  return data;
}

export async function createDeviceCategory(body: DeviceCategoryInput): Promise<DeviceCategoryDto> {
  const { data } = await apiClient.post<DeviceCategoryDto>("/device-categories", body);
  return data;
}

export async function updateDeviceCategory(id: string, body: DeviceCategoryInput): Promise<DeviceCategoryDto> {
  const { data } = await apiClient.patch<DeviceCategoryDto>(`/device-categories/${id}`, body);
  return data;
}

export async function listAssignableDeviceCategories(includeId?: string | null): Promise<DeviceCategoryDto[]> {
  const { data } = await apiClient.get<DeviceCategoryDto[]>("/device-categories/options", { params: includeId ? { include_id: includeId } : undefined });
  return data;
}

export async function listDeviceCategoryFilterOptions(): Promise<DeviceCategoryDto[]> {
  const { data } = await apiClient.get<DeviceCategoryDto[]>("/device-categories/filter-options");
  return data;
}
